import React from 'react';
import PropTypes from 'prop-types';
import EnvironmentManager from 'Utils/environmentManager';
import { URL_MAP_BY_TYPE } from 'Store/constants/sportTypes';

const SportTypeIcon = ({ type }) => {
  const defaultIconUrl = '/public/images/icons/ic-bahis-yap-green.svg';
  const iconSrc = EnvironmentManager.sportTypeHash[type] || defaultIconUrl;

  return <div className="icon icon-sports">
    <img src={ iconSrc } alt={ URL_MAP_BY_TYPE[type] } />
  </div>;
};

SportTypeIcon.propTypes = {
  type: PropTypes.number
};

export default SportTypeIcon;
